import { render, staticRenderFns } from "./consents-card.vue?vue&type=template&id=369296f8&scoped=true&"
import script from "./consents-card.vue?vue&type=script&lang=ts&"
export * from "./consents-card.vue?vue&type=script&lang=ts&"
import style0 from "./consents-card.vue?vue&type=style&index=0&id=369296f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369296f8",
  null
  
)

export default component.exports